module.exports = __webpack_public_path__ + "img/admin-white.3141f67f.svg";